import en from './en';

const translations = {
  en,
};

export default translations;
